module.exports = __webpack_public_path__ + "static/media/discussionpost.3d13c8f1.png";